import { fmtNum, fmtEur, fmtDate } from "@/lib/format";

export const DailyCostTable = ({ daily }) => {
  const rows = [...daily].reverse();
  if (!rows.length) return <p className="py-8 text-center text-sm text-slate-400">Nessun dato</p>;
  return (
    <div className="max-h-96 overflow-auto">
      <table className="w-full text-sm" data-testid="daily-cost-table">
        <thead className="sticky top-0 border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
          <tr>
            <th className="px-4 py-2">Data</th><th className="px-4 py-2 text-right">Mezzi</th><th className="px-4 py-2 text-right">KM</th>
            <th className="px-4 py-2 text-right">Gasolio IVA incl.</th><th className="px-4 py-2 text-right">€/km IVA incl.</th>
            <th className="px-4 py-2 text-right">€/km netto</th><th className="px-4 py-2 text-right">€/mezzo</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {rows.map((d) => (
            <tr key={d.date} className="hover:bg-slate-50" data-testid={`daily-row-${d.date}`}>
              <td className="whitespace-nowrap px-4 py-2 font-medium">{fmtDate(d.date)}</td>
              <td className="font-mono-num px-4 py-2 text-right">{d.total_vehicles}</td>
              <td className="font-mono-num px-4 py-2 text-right">{fmtNum(d.total_km, 0)}</td>
              <td className="font-mono-num px-4 py-2 text-right">{fmtEur(d.total_cost)}</td>
              <td className="font-mono-num px-4 py-2 text-right">{fmtNum(d.cost_per_km, 3)}</td>
              <td className={`font-mono-num px-4 py-2 text-right font-semibold ${d.reimbursement_per_km && d.cost_per_km_net > d.reimbursement_per_km ? "bg-rose-50 text-rose-600" : ""}`} data-testid={`daily-ckm-${d.date}`}>{fmtNum(d.cost_per_km_net, 3)}</td>
              <td className="font-mono-num px-4 py-2 text-right">{fmtEur(d.cost_per_vehicle)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
